import { useInfiniteQuery } from "react-query";
import api from "../api/API";
import { lastPageNumber, nextPageNumber } from "../util/api";
import { useCreateToast } from "./toasts";

const fetchSeshes = async ({ pageParam = 1 }) => {
  return await api.seshes.getPaged(pageParam, 10).then(
    (result) => ({
      seshes: result.seshes,
      nextPage: nextPageNumber(result.headers.link),
      lastPage: lastPageNumber(result.headers.link),
    }),
    (error) => {
      const createToast = useCreateToast();
      createToast("danger", "Error fetching seshes. Please try again");
      console.error(error);
    }
  );
};

export const useSeshes = () => {
  return useInfiniteQuery("seshes", fetchSeshes, {
    getNextPageParam: (mostRecentPage, pages) => {
      return mostRecentPage.nextPage;
    },
  });
};
